module.exports = __webpack_public_path__ + "static/media/celery.5ea8b45a.png";